import Table from '@/components/common/Table'
import useCrashDetectionMonitorTableHook from './CrashDetectionMonitorTable.hook'
import { CardContainer, TableContainer, UnrespondedCountBox } from './styles'

const CrashDetectionMonitorTable = () => {
  const { data, isLoading, columns, onTableChange, setSelectedRowId, selectedRowId } =
    useCrashDetectionMonitorTableHook()

  return (
    <CardContainer>
      <UnrespondedCountBox>
        <div className="label">จำนวนเคสที่ยังไม่ได้รับการติดต่อกลับ</div>
        <div className="count">{data?.data?.totalCaseNotResponse || 0}</div>
      </UnrespondedCountBox>
      <TableContainer>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data?.data?.caseList || []}
          loading={isLoading}
          scroll={{ x: 1480 }}
          sticky={true}
          pagination={{
            pageSizeOptions: [10, 25, 50, 100],
            showSizeChanger: true,
            total: data?.meta.totalItems,
            current: data?.meta.currentPage,
            pageSize: data?.meta.itemsPerPage,
          }}
          onChange={onTableChange}
          onRow={(record) => ({
            onClick: () => setSelectedRowId(record.id === selectedRowId ? null : record.id),
          })}
          rowClassName={(record) => (record.id === selectedRowId ? 'selected-row' : '')}
        />
      </TableContainer>
    </CardContainer>
  )
}

export default CrashDetectionMonitorTable
